<template>
  <div>
    <v-card 
      v-show="editMode"
      data-cy="dataset-description-card-edit"
    >
      <v-card-title class="headline primary white--text">
        ReadMe
      </v-card-title>
      <v-card-text>
        <v-textarea 
          v-if="editMode"
          box
          label="Description"
          :error-messages="textFieldErrors($v.datasetReadme)"
          v-model="datasetReadme"
          :hint="`${datasetReadme.length}/3000 Characters - Description of your dataset.`"
          required
          @input="$v.datasetReadme.$touch()"
          @blur="$v.datasetReadme.$touch()"
          data-cy="dataset-desc-textarea"
        >
        </v-textarea>
      </v-card-text>
  </v-card>
    <v-card 
      v-show="!editMode"
      data-cy="dataset-card-view">
      <v-card-title class="headline primary white--text">
          Read Me / Documentation
      </v-card-title>
      <v-card-text :class="{ presentation: getPresentMode }">
        <vue-markdown v-bind:source="dataset.dataset_desc"></vue-markdown>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from 'vuex'
import { required, maxLength } from 'vuelidate/lib/validators'
import { validationMixin } from '../validators.js'
import VueMarkdown from 'vue-markdown'

export default {
  mixins: [validationMixin],
  props: {
    editMode: {
      type: Boolean,
      default: false
    }
  },
  components: {
    VueMarkdown
  },
  validations: {
    datasetReadme: {
      required,
      maxLength: maxLength(3000)
    }
  },
  computed: {
    ...mapGetters([
      'getCurrentDataset',
      'getTopLevelFields',
      'getDatasetEdits',
      'getPresentMode'
    ]),
    dataset () {
      return this.getCurrentDataset
    },
    datasetReadme: {
      get () {
        return this.$store.getters.getDatasetEdits.dataset_desc
      },
      set (val) {
        this.setDatasetEdit({
          key: 'dataset_desc',
          value: val
        })
      }
    }
  },
  mounted () {
    this.$watch('$v', (newVal, oldVal) => {
        this.setTopFieldsInvalid(newVal.$invalid)
      }, { deep: true })
  },
  methods: {
    ...mapActions([
      'removeItemAction',
      'addItemAction',
      'editItemAction'
    ]),
    ...mapMutations([
      'setView',
      'logError',
      'setDatasetEdit',
      'setDatasetKey',
      'setTopFieldsInvalid'
    ]),
    setDataset (arg) {
      this.setDatasetKey(arg)
    }
  }
}
</script>